<div class="flex flex-col">
    <div class="shadow-box flex flex-col items-center max-w-screen-sm">
        <!-- <img src="../../assets/img/login-penguin.webp" class="mt-12 mb-6 w-40 h-40 rounded-full"/> -->
        <h3>Registrierung</h3>
        <div class="divide-y">
            <div class="mb-4">
                <p class="px-4 mt-2 mb-4 text-center">Schnellster Weg: Registriere dich mit einem bestehenden Konto bei
                    einem anderen Anbieter.</p>
                <app-social-login [returnUrl]="returnUrl"></app-social-login>
            </div>

            <div class="my-4">
                <p class="px-4 mt-2 mb-4 text-center">Alternativ: Anmeldung mit E-Mail & Passwort</p>

                <form (ngSubmit)="onSubmit()" [formGroup]="registrationForm">
                    <div>
                        <label for="email" class="block text-sm font-medium leading-6">E-Mail-Adresse</label>
                        <div class="mt-2">
                            <input id="email" formControlName="email" name="email"
                                class="block w-full rounded border border-grey py-1.5" type="email" required [ngClass]="{
                                    'invalid': registrationForm.get('email')?.invalid && (registrationForm.get('email')?.touched)
                                  }">
                            @if (registrationForm.get('email')?.invalid && (registrationForm.get('email')?.touched)) {
                            <div class="text-red text-sm mt-2">
                                Ungültige E-Mail-Adresse
                            </div>
                            }
                        </div>
                    </div>

                    <div class="my-4">
                        <label for="password" class="block text-sm font-medium leading-6">Passwort</label>
                        <div class="mt-2">
                            <input id="password" formControlName="password" name="password"
                                class="block w-full rounded border border-grey py-1.5" type="password" required
                                placeholder="" [ngClass]="{
                                    'invalid': registrationForm.get('password')?.invalid && (registrationForm.get('password')?.touched)
                                  }">
                            @if (registrationForm.get('password')?.invalid &&
                            (registrationForm.get('password')?.touched)) {
                            <div class="text-red text-sm mt-2">
                                Passwort muss aus mindestens 8 Zeichen beinhalten
                            </div>
                            }
                        </div>
                    </div>

                    <div class="my-4">
                        <label for="passwordConfirm" class="block text-sm font-medium leading-6">Passwort
                            Wiederholen</label>
                        <div class="mt-2">
                            <input id="passwordConfirm" formControlName="passwordConfirm" name="passwordConfirm"
                                class="block w-full rounded border border-grey py-1.5" type="password" required
                                placeholder="" [ngClass]="{
                                    'invalid': registrationForm.invalid && (registrationForm.get('passwordConfirm')?.touched && registrationForm.hasError('notSame'))
                                  }">
                            @if (registrationForm.invalid && (registrationForm.get('passwordConfirm')?.touched &&
                            registrationForm.hasError('notSame'))) {
                            <div class="text-red text-sm mt-2">
                                Passwörter stimmen nicht überein
                            </div>
                            }
                        </div>
                    </div>

                    <div class="w-full flex flex-row justify-end items-center gap-4">
                        @if(verificationSent){
                        <span class="text-green">Wir haben dir eine Bestätigungsmail geschickt. Klicke auf den Bestätigungslink
                            darin, um deine Registrierung abzuschließen. Solltest du die E-Mail nicht finden, prüfe bitte auch deinen Spam-Ordner.</span>
                        } @else if(registrationFailed){
                        <span class="text-red">{{ registrationFailureMessage }}</span>
                        }
                        @if (registrationForm.invalid) {
                        <button type="submit" disabled
                            class="white-button disabled cursor-not-allowed !h-12">Registrieren</button>
                        } @else {
                        <button type="submit" class="blue-button !h-12">Registrieren</button>
                        }
                    </div>
                </form>
            </div>
            <div class="my-4">
                <p class="px-4 mt-2 mb-4 text-center">Du hast bereits einen Account? <a routerLink="/login">Jetzt
                        Einloggen!</a></p>
            </div>
        </div>
    </div>
</div>